export default "__VITE_ASSET__BCMLosAi__"